// extracted by mini-css-extract-plugin
module.exports = {"header":"SiteHeader_header__i8oOb","logo":"SiteHeader_logo__20QLV"};